import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

import {
  createBrowserRouter,
  RouterProvider,
  Navigate, // Đảm bảo sử dụng Navigate thay cho Redirect
} from "react-router-dom";

import "./assets/styles/reset.css";
import "./assets/styles/layout/Main.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import Login from "./components/login/Login";
import GenerateCode from "./components/page/GenerateCode";
import Page404 from "./components/page/page404";
import UserManage from "./components/page/UserManage";
import Setting from "./components/page/setting";
import Whitelist from "./components/page/whitelist";
import Locales from "./components/Locales";
import { ConfigProvider } from "./contexts/ConfigContext";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <GenerateCode />,
    },
    {
      path: "/user-manager",
      element: <UserManage />,
    },
    {
      path: "/setting",
      element: <Setting />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/ip",
      element: <Whitelist />,
    },
    {
      path: "/404",
      element: <Page404 />,
    },
    {
      path: "*",
      element: <Navigate to="/404" />,
    },
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ConfigProvider>
    <Locales>
      <React.StrictMode>
        <RouterProvider router={router} />
      </React.StrictMode>
    </Locales>
  </ConfigProvider>
);

reportWebVitals();
